import { render, staticRenderFns } from "./UserMigration.vue?vue&type=template&id=afacdeae&scoped=true"
import script from "./UserMigration.vue?vue&type=script&lang=js"
export * from "./UserMigration.vue?vue&type=script&lang=js"
import style0 from "./UserMigration.vue?vue&type=style&index=0&id=afacdeae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afacdeae",
  null
  
)

export default component.exports